// extracted by mini-css-extract-plugin
export default {"Container":"RootLayout_Container__5lN2z","Content":"RootLayout_Content__53Aek"};